import { COMPONENT_TYPES } from "../constants";

export const RANGE_MAX = 10000000;

export const UNITS = Object.freeze({
  Minute: "MINUTE",
  Hour: "HOUR",
  Day: "DAY",
  Month: "MONTH",
  Year: "YEAR",
});

export const LIMITS = Object.freeze({
  [UNITS.Minute]: 5256000,
  [UNITS.Hour]: 86700,
  [UNITS.Day]: 3650,
  [UNITS.Month]: 12,
  [UNITS.Year]: 5,
});

export const SELECT_COMPONENT_TYPES_LIST = [
  COMPONENT_TYPES.SingleSelect,
  COMPONENT_TYPES.MultiSelect,
  COMPONENT_TYPES.MultiSelectGrouped,
];

export const RESOLVED_COMPONENT_TYPES = Object.freeze({
  [COMPONENT_TYPES.MultiSelectGrouped]: COMPONENT_TYPES.MultiSelect,
});
